module.exports = __webpack_public_path__ + "assets/img/ktz_img3.51b2bc8e.png";